import 'slick-carousel';

export default {
    init() {
        this.accredsCarouselList()
        this.awardsCarouselList()
        this.apartmentSlider()
        this.imageCarouselList()
    },

    accredsCarouselList(){

        const $accredsCarouselList = $('.accreditations-list')

        // slick slider initiation
		if ($accredsCarouselList.length) {
	        $accredsCarouselList.slick({
	            infinite: true,
	            variableWidth: false,
	            draggable: true,
	            arrows: true,
                prevArrow: $('.accreditations-list-wrap .site-arrow--prev'),
                nextArrow: $('.accreditations-list-wrap .site-arrow--next'),
				dots: false,
	            autoplay: true,
	            autoplaySpeed: 5000,
	            pauseOnFocus: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    dots: false,
                    arrows: false
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false
                  }
                }
              ]
	        })
		}

    },

    awardsCarouselList(){

        const $awardsCarouselList = $('.awards-list')
        const $awardsCarouselText = $('.awards-list-text')

        // slick slider initiation
        if ($awardsCarouselList.length && $awardsCarouselText.length ) {


            $awardsCarouselList.slick({
                infinite: true,
                variableWidth: false,
                draggable: false,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3500,
                pauseOnFocus: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                focusOnSelect: true,
                asNavFor: $awardsCarouselText,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                        }
                    }
                ]
            })

            $awardsCarouselText.slick({
                infinite: true,
                fade: true,
                variableWidth: false,
                draggable: false,
                arrows: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 3500,
                pauseOnFocus: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                focusOnSelect: true,
                asNavFor: $awardsCarouselList,

                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            })
        }

    },

    imageCarouselList(){

        const $imageCarouselList = $('.image-text-list')

        // slick slider initiation
        if ( $imageCarouselList.length ) {

            $imageCarouselList.slick({
                infinite: false,
                variableWidth: false,
                draggable: true,
                arrows: false,
                dots: true,
                fade: true,
                autoplay: true,
                autoplaySpeed: 3500,
                pauseOnFocus: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            })
        }

    },

    apartmentSlider(){

        const $apartmentSliderCenter = $('.team-slider')

        // slick slider initiation
        if ($apartmentSliderCenter.length) {

          $apartmentSliderCenter.slick({
            centerMode: true,
            slidesToShow: 3,
            arrows: false,
            centerPadding: '0px',
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                        settings: {
                        draggable: true,
                        slidesToShow: 1,
                        centerPadding: '10px',
                        centerMode: false,
                        slidesToScroll: 1,
                        centerMode: true,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        draggable: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
          })
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/slider.js